module.exports = "<ithera-header class=\"header-fixed\"></ithera-header>\n <div class=\"container content-top\">\n <div class=\"row margin-bottom-10\"> \n    <!-- <div class=\"col-md-12\"> -->\n<router-outlet></router-outlet>\n <!-- </div> -->\n </div>\n </div>\n<!-- <footer></footer>-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main